import React, { useContext, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsers, faTable } from "@fortawesome/pro-solid-svg-icons";
import UserContext from "../../../state/UserContext";

type ViewType = "Table View" | "User View";

interface ListViewToggleProps {
  onToggle: (view: ViewType) => void;
  defaultView?: ViewType;
  showUserViewFirst?: boolean;
}

const ListViewToggle: React.FC<ListViewToggleProps> = ({
  onToggle,
  defaultView = "Table View",
  showUserViewFirst = false,
}) => {
  const userContext = useContext(UserContext);
  const [selectedView, setSelectedView] = useState<ViewType>(defaultView);

  const primaryColor = userContext?.user?.client.primaryHexColour;

  const handleToggle = (view: ViewType) => {
    setSelectedView(view);
    onToggle(view);
  };

  const tableViewButton = (
    <button
      className={`flex items-center rounded-md py-2 px-3 sm:px-4 text-sm font-medium flex-1 sm:flex-none justify-center sm:justify-start ${
        selectedView === "Table View"
          ? "primary-text font-semibold border primary-border"
          : "text-gray-600 hover:bg-gray-100"
      }`}
      style={
        selectedView === "Table View"
          ? { backgroundColor: `#${primaryColor}10` }
          : {}
      }
      onClick={() => handleToggle("Table View")}
    >
      <FontAwesomeIcon icon={faTable} className="mr-2" />
      Table View
    </button>
  );

  const userViewButton = (
    <button
      className={`flex items-center rounded-md py-2 px-3 sm:px-4 text-sm font-medium flex-1 sm:flex-none justify-center sm:justify-start ${
        selectedView === "User View"
          ? "primary-text font-semibold border primary-border"
          : "text-gray-600 hover:bg-gray-100"
      }`}
      style={
        selectedView === "User View"
          ? { backgroundColor: `#${primaryColor}10` }
          : {}
      }
      onClick={() => handleToggle("User View")}
    >
      <FontAwesomeIcon icon={faUsers} className="mr-2" />
      User View
    </button>
  );

  return (
    <div className="flex w-full sm:w-auto">
      {showUserViewFirst ? (
        <>
          {userViewButton}
          <div className="ml-2">{tableViewButton}</div>
        </>
      ) : (
        <>
          {tableViewButton}
          <div className="ml-2">{userViewButton}</div>
        </>
      )}
    </div>
  );
};

export default ListViewToggle;
